module.exports = __webpack_public_path__ + "img/prehled-mapa_350.8e9b066f.gif";